import { Pipe, PipeTransform } from '@angular/core';
import { TranstationFactory } from 'src/app/core/translation.factory';

@Pipe({
  name: 'paymentUnit'
})
export class PaymentUnitPipe implements PipeTransform {

  constructor(
    private translate: TranstationFactory,
  ) { }

  transform(value: any, args?: any): any {
    let key = '';
    if (value === 1) {
      key = 'mode_of_payment.annual_per';
    } else if (value === 2) {
      key = 'mode_of_payment.half_yearly_per';
    } else if (value === 3) {
      key = 'mode_of_payment.quarterly_per';
    } else if (value === 4) {
      key = 'mode_of_payment.monthly_per';
    } else if (value === 5) {
      key = ' ';
    }

    return key === '' ? value : this.translate.get(key);
  }

}
